import { render, staticRenderFns } from "./ReportSetting.vue?vue&type=template&id=2b5b74b2&scoped=true&"
import script from "./ReportSetting.vue?vue&type=script&lang=js&"
export * from "./ReportSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5b74b2",
  null
  
)

export default component.exports